import React from 'react';
import WidgetConversationsChat from '../../components/Assistant/WidgetConversationsChat';

function ConversationsPage() {
  return (
    <div className="h-[calc(100vh-180px)] overflow-hidden">
      <WidgetConversationsChat />
    </div>
  );
}

export default ConversationsPage;
